// dev config
//export const APIUrl = 'http://localhost:81/rwa/api/index.php/api/';

// production config
export const APIUrl = 'https://mcboa.in/api/index.php/api/';
